<script>
import SlotMachineSlot from "./SlotMachineSlot.svelte";

let santaTop
let santaMiddle
let santaBottom

let slots
let index

export const start = () => {
    santaTop.start()
    santaMiddle.start()
    santaBottom.start()
    slots = [santaTop, santaMiddle, santaBottom]
    index = 0
}

const clothesMap = {
    gd: 2,
    tw: 6,
    fb: 5,
    ig: 7,
    lk: 4,
    sw: 3,
    nd: 1,
}

export const stop = (cloth) => {
    if(index >= slots.length) {
        return
    }
    slots[index++].stop(clothesMap[cloth])
    // fire event ?
}

export const ensureStop = () => {
    slots && slots.forEach(s => s.stop(clothesMap['nd']));
}
</script>

<div id="game-santa">
    <SlotMachineSlot id="santa-top" imgFolder="./img/imgs-splittees/top/" bind:this={santaTop} />
    <SlotMachineSlot id="santa-middle" imgFolder="./img/imgs-splittees/middle/" bind:this={santaMiddle} />
    <SlotMachineSlot id="santa-bottom" imgFolder="./img/imgs-splittees/btm/" bind:this={santaBottom} />
</div>

<style>
	
</style>
